import { Link } from 'react-router-dom';
import {
  EGB_DATA_ID,
  COUNCIL_ROLES,
  COUNCIL_FUNCTIONS,
  DATA_PRINCIPLES,
  MASTER_DATA_ENTITIES,
  METADATA_GOVERNANCE,
  DATA_CATALOG,
  DATA_LINEAGE,
  QUALITY_DIMENSIONS,
  DATA_LIFECYCLE,
  DATA_PRIVACY,
  AI_DATA_GOVERNANCE,
  ANALYTICS_GOVERNANCE,
  DATA_STEWARDSHIP,
  DATA_MONITORING,
  EXECUTIVE_DASHBOARD,
  ACCESSIBILITY,
  ARCHITECTURE_STAGES,
  LIVE_ROUTES,
  DEMO_COUNCIL,
  DEMO_PRINCIPLES,
  DEMO_MASTER_DATA,
  DEMO_METADATA_CATALOG,
  DEMO_LINEAGE,
  DEMO_QUALITY,
  DEMO_LIFECYCLE_PRIVACY,
  DEMO_EXECUTIVE,
  buildDataDashboard,
} from '../../datagovernance/framework';
import {
  DataCouncilPanel,
  DataPrinciplesPanel,
  MasterDataPanel,
  MetadataCatalogPanel,
  DataLineagePanel,
  DataQualityPanel,
  DataLifecyclePrivacyPanel,
  ExecutiveDataDashboardPanel,
} from '../../components/datagovernance';
import { Card, KpiCard } from '../../components/ui';

export function DataGovernancePage() {
  const dashboard = buildDataDashboard();

  return (
    <div className="space-y-8">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-brand-600">{EGB_DATA_ID}</p>
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-100">Enterprise Data Governance</h1>
        <p className="mt-1 text-sm text-slate-500">
          Permanent Data Constitution — master data, metadata, lineage, quality, privacy, and AI readiness.
          Fully aligned with MPC-00001 and all Enterprise Governance Bibles.
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          {Object.entries(LIVE_ROUTES).map(([key, path]) => (
            <Link
              key={key}
              to={path}
              className="rounded-lg border border-cyan-200 bg-cyan-50 px-3 py-1.5 text-xs font-medium text-cyan-700 hover:bg-cyan-100 dark:border-cyan-900 dark:bg-cyan-950 dark:text-cyan-300"
            >
              {path}
            </Link>
          ))}
        </div>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
        <KpiCard label="Council Roles" value={dashboard.council_roles.toString()} />
        <KpiCard label="Data Principles" value={dashboard.data_principles.toString()} />
        <KpiCard label="Master Data Entities" value={dashboard.master_data_entities.toString()} />
        <KpiCard label="Quality Dimensions" value={dashboard.quality_dimensions.toString()} />
        <KpiCard label="Governance Areas" value={dashboard.governance_areas.toString()} />
      </div>

      <section>
        <h2 className="text-lg font-semibold">Data Architecture</h2>
        <div className="mt-3 flex flex-wrap gap-2">
          {ARCHITECTURE_STAGES.map((s, i) => (
            <span key={s} className="flex items-center gap-1 text-xs">
              <span className="rounded-lg border border-slate-200 px-2 py-1 dark:border-slate-700">{s}</span>
              {i < ARCHITECTURE_STAGES.length - 1 && <span className="text-slate-400">→</span>}
            </span>
          ))}
        </div>
      </section>

      <section>
        <h2 className="text-lg font-semibold">Data Governance Council</h2>
        <p className="mt-1 text-sm text-slate-500">{COUNCIL_ROLES.join(' · ')}</p>
        <p className="mt-1 text-xs text-slate-400">{COUNCIL_FUNCTIONS.join(' · ')}</p>
        <Card className="mt-4" padding="sm">
          <DataCouncilPanel members={DEMO_COUNCIL} />
        </Card>
      </section>

      <section>
        <h2 className="text-lg font-semibold">Enterprise Data Principles</h2>
        <p className="mt-1 text-sm text-slate-500">{DATA_PRINCIPLES.join(' · ')}</p>
        <Card className="mt-4" padding="sm">
          <DataPrinciplesPanel items={DEMO_PRINCIPLES} />
        </Card>
      </section>

      <section>
        <h2 className="text-lg font-semibold">Master Data Management</h2>
        <p className="mt-1 text-sm text-slate-500">{MASTER_DATA_ENTITIES.join(' · ')}</p>
        <Card className="mt-4" padding="sm">
          <MasterDataPanel items={DEMO_MASTER_DATA} />
        </Card>
      </section>

      <section>
        <h2 className="text-lg font-semibold">Metadata & Data Catalog</h2>
        <p className="mt-1 text-sm text-slate-500">{METADATA_GOVERNANCE.join(' · ')} · {DATA_CATALOG.join(' · ')}</p>
        <Card className="mt-4" padding="sm">
          <MetadataCatalogPanel items={DEMO_METADATA_CATALOG} />
        </Card>
      </section>

      <section>
        <h2 className="text-lg font-semibold">Data Lineage</h2>
        <p className="mt-1 text-sm text-slate-500">{DATA_LINEAGE.join(' · ')}</p>
        <Card className="mt-4" padding="sm">
          <DataLineagePanel items={DEMO_LINEAGE} />
        </Card>
      </section>

      <section>
        <h2 className="text-lg font-semibold">Data Quality</h2>
        <p className="mt-1 text-sm text-slate-500">{QUALITY_DIMENSIONS.join(' · ')}</p>
        <Card className="mt-4" padding="sm">
          <DataQualityPanel items={DEMO_QUALITY} />
        </Card>
      </section>

      <section>
        <h2 className="text-lg font-semibold">Lifecycle, Privacy & AI Data</h2>
        <p className="mt-1 text-sm text-slate-500">
          {DATA_LIFECYCLE.join(' · ')} · {DATA_PRIVACY.join(' · ')} · {AI_DATA_GOVERNANCE.join(' · ')}
        </p>
        <Card className="mt-4" padding="sm">
          <DataLifecyclePrivacyPanel items={DEMO_LIFECYCLE_PRIVACY} />
        </Card>
      </section>

      <section>
        <h2 className="text-lg font-semibold">Executive Data Dashboard</h2>
        <p className="mt-1 text-sm text-slate-500">
          {ANALYTICS_GOVERNANCE.join(' · ')} · {DATA_STEWARDSHIP.join(' · ')} · {DATA_MONITORING.join(' · ')} · {EXECUTIVE_DASHBOARD.join(' · ')} · {ACCESSIBILITY.join(' · ')}
        </p>
        <Card className="mt-4" padding="sm">
          <ExecutiveDataDashboardPanel items={DEMO_EXECUTIVE} />
        </Card>
      </section>
    </div>
  );
}
